import * as React from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import styled from "styled-components";
import ClickableElement from "../../utils/ClickableElement";

const ComponentsList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0.5rem 0 0.5rem 0.5rem;
`;

const ComponentsListHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-left: 1.28rem;
`;

const ComponentsListBody = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors.lightgrey};
  margin-left: 2rem;
  margin-top: 0.5rem;
  padding-left: 0.5rem;
`;

const ListExpanderButton = styled(ClickableElement)`
  justify-content: flex-end;
`;

interface ICourseComponentListProps {
  renderHeader?: () => JSX.Element;
}

interface ICourseComponentListState {
  expanded: boolean;
}

export default class CourseComponentList extends React.Component<ICourseComponentListProps, ICourseComponentListState> {
  constructor(props: ICourseComponentListProps) {
    super(props);

    this.state = {
      expanded: true,
    };
  }

  public toggleExpanded = () => this.setState({ expanded: !this.state.expanded });

  public render() {
    return (
      <ComponentsList>
        {this.props.renderHeader && (
          <ComponentsListHeader>
            {this.props.renderHeader()}
            <ListExpanderButton onClick={this.toggleExpanded}>
              {this.state.expanded ? <FaChevronDown /> : <FaChevronRight />}
            </ListExpanderButton>
          </ComponentsListHeader>
        )}
        {this.state.expanded && <ComponentsListBody>{this.props.children}</ComponentsListBody>}
      </ComponentsList>
    );
  }
}
